// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box, Container, Card, CardContent, Typography,
    TextField, Button, Alert, CircularProgress
} from '@mui/material';
import { Email, ArrowBack } from '@mui/icons-material';
import NavbarMain from '../components/NavbarMain';
import axios from 'axios';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email.trim()) { setError('Внесете email адреса'); return; }

        try {
            setLoading(true);
            setError('');
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/forgot-password`, { email });
            setSuccess(res.data.message);
        } catch (err) {
            setError(err.response?.data?.message || 'Серверска грешка. Обидете се повторно.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <NavbarMain />
            <Box sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #ffeef8 0%, #e0f7ff 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                pt: 10, pb: 6, px: 2
            }}>
                <Container maxWidth="sm">
                    <Card sx={{
                        borderRadius: '20px', overflow: 'hidden',
                        boxShadow: '0 8px 32px rgba(255,126,185,0.15)',
                        border: '1px solid rgba(255,126,185,0.2)'
                    }}>
                        {/* Header */}
                        <Box sx={{
                            background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                            p: 4, textAlign: 'center'
                        }}>
                            <Box sx={{
                                width: 64, height: 64, borderRadius: '50%',
                                bgcolor: 'rgba(255,255,255,0.2)',
                                display: 'flex', alignItems: 'center',
                                justifyContent: 'center', mx: 'auto', mb: 2
                            }}>
                                <Email sx={{ fontSize: 36, color: 'white' }} />
                            </Box>
                            <Typography variant="h4" sx={{ color: 'white', fontWeight: 900 }}>
                                Зборавена лозинка?
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.85)', mt: 1 }}>
                                Внесете ја вашата email адреса и ќе ви испратиме линк за ресетирање
                            </Typography>
                        </Box>

                        <CardContent sx={{ p: 4 }}>
                            {success ? (
                                <Box textAlign="center">
                                    <Typography variant="h2" sx={{ mb: 2 }}>📧</Typography>
                                    <Alert severity="success" sx={{ mb: 3, borderRadius: '12px' }}>
                                        {success}
                                    </Alert>
                                    <Typography variant="body2" sx={{ color: '#888', mb: 3 }}>
                                        Проверете го вашиот inbox (и spam folder). Линкот е валиден 15 минути.
                                    </Typography>
                                    <Button variant="outlined" onClick={() => navigate('/login')}
                                            startIcon={<ArrowBack />}
                                            sx={{ borderColor: '#ff7eb9', color: '#ff7eb9', borderRadius: '12px' }}>
                                        Назад кон логирање
                                    </Button>
                                </Box>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    {error && (
                                        <Alert severity="error" sx={{ mb: 3, borderRadius: '12px' }}>
                                            {error}
                                        </Alert>
                                    )}

                                    <TextField
                                        fullWidth label="Email адреса"
                                        type="email" value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="vashiot@email.com"
                                        sx={{
                                            mb: 3,
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '12px',
                                                '&:hover fieldset': { borderColor: '#ff7eb9' },
                                                '&.Mui-focused fieldset': { borderColor: '#ff7eb9' }
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': { color: '#ff7eb9' }
                                        }}
                                    />

                                    <Button fullWidth type="submit" variant="contained"
                                            disabled={loading}
                                            sx={{
                                                background: 'linear-gradient(45deg, #ff7eb9, #AB47BC)',
                                                borderRadius: '12px', py: 1.5,
                                                fontSize: '1rem', fontWeight: 'bold',
                                                '&:hover': { background: 'linear-gradient(45deg, #ff4a97, #9C27B0)' }
                                            }}>
                                        {loading ? <CircularProgress size={24} color="inherit" /> : '📧 Испрати линк за ресетирање'}
                                    </Button>

                                    <Button fullWidth onClick={() => navigate('/login')}
                                            startIcon={<ArrowBack />}
                                            sx={{ mt: 2, color: '#888', borderRadius: '12px' }}>
                                        Назад кон логирање
                                    </Button>
                                </form>
                            )}
                        </CardContent>
                    </Card>
                </Container>
            </Box>
        </>
    );
};

export default ForgotPassword;